



























import { bookModelProvider } from '../model'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent } from '@/hooks'

export default defineClassComponent(
  () =>
    class {
      bookModel = bookModelProvider.inject()

      handleFavoriteClick = () => {
        this.bookModel.value.toggleFavorite()
      }

      handleShareClick = () => {
        dcb.share({
          title: this.bookModel.value.store.storeName,
          desc: this.bookModel.value.store.openPeriod,
          url: location.href,
          cover: this.bookModel.value.store.storeLogo,
        })
      }
    },
)
